/**
 * ADMIN RESTRINGIDO (14/10/2026, "Mentora Imperium"). Espejo del backend
 * (`lib/restriccionesDeUsuario.ts`): un admin puede tener secciones del menú cerradas y
 * oficinas que no existen para él. Las oficinas las filtra el backend; acá se cierran las
 * secciones: no aparecen en el menú y la pantalla no abre (ver `DashboardLayout`).
 */
export const SECCIONES = ['marketplace', 'facturacion', 'configuracion', 'integraciones', 'tablero'] as const;
export type Seccion = (typeof SECCIONES)[number];

export const NOMBRE_SECCION: Record<Seccion, string> = {
  marketplace: 'Marketplace', facturacion: 'Facturación', configuracion: 'Configuración', integraciones: 'Integraciones', tablero: 'Tablero',
};

/** Las pantallas de cada sección (las del menú y sus hijas). */
const RUTAS: Record<Seccion, string[]> = {
  marketplace:   ['/marketplace'],
  facturacion:   ['/admin/revenue', '/admin/comisiones', '/admin/payments', '/admin/wallets', '/admin/credits', '/admin/operation-fees'],
  configuracion: ['/admin/web-content', '/admin/infocasas'],
  integraciones: ['/integrations'],
  tablero:       ['/tablero'],
};

/** ¿Esta ruta es de una sección que el usuario tiene oculta? Devuelve cuál, o null. */
export function seccionOculta(secciones: readonly string[] | undefined, path: string | undefined): Seccion | null {
  if (!secciones?.length || !path) return null;
  for (const s of secciones) {
    if ((RUTAS[s as Seccion] ?? []).some((r) => path === r || path.startsWith(`${r}/`))) return s as Seccion;
  }
  return null;
}
